export const FETCH_SKUS_REQUEST = 'FETCH_SKUS_REQUEST';
export const FETCH_SKUS_SUCCESS = 'FETCH_SKUS_SUCCESS';
export const FETCH_SKUS_FAILED = 'FETCH_SKUS_FAILED';

export const FETCH_SKU_BY_ID_REQUEST = 'FETCH_SKU_BY_ID_REQUEST';
export const FETCH_SKU_BY_ID_SUCCESS = 'FETCH_SKU_BY_ID_SUCCESS';
export const FETCH_SKU_BY_ID_FAILED = 'FETCH_SKU_BY_ID_FAILED';

export const FETCH_DELETE_SKU_REQUEST = 'FETCH_DELETE_SKU_REQUEST';
export const FETCH_DELETE_SKU_SUCCESS = 'FETCH_DELETE_SKU_SUCCESS';
export const FETCH_DELETE_SKU_FAILED = 'FETCH_DELETE_SKU_FAILED';

export const FETCH_UPDATE_SKU_REQUEST = 'FETCH_UPDATE_SKU_REQUEST';
export const FETCH_UPDATE_SKU_SUCCESS = 'FETCH_UPDATE_SKU_SUCCESS';
export const FETCH_UPDATE_SKU_FAILED = 'FETCH_UPDATE_SKU_FAILED';

export const FETCH_CREATE_SKU_REQUEST = 'FETCH_CREATE_SKU_REQUEST';
export const FETCH_CREATE_SKU_SUCCESS = 'FETCH_CREATE_SKU_SUCCESS';
export const FETCH_CREATE_SKU_FAILED = 'FETCH_CREATE_SKU_FAILED';

export const FETCH_ASSOCIATED_TAX_RULESET_REQUEST = 'FETCH_ASSOCIATED_TAX_RULESET_REQUEST';
export const FETCH_ASSOCIATED_TAX_RULESET_SUCCESS = 'FETCH_ASSOCIATED_TAX_RULESET_SUCCESS';
export const FETCH_ASSOCIATED_TAX_RULESET_FAILED = 'FETCH_ASSOCIATED_TAX_RULESET_FAILED';

export const RESET_ONBOARDING = 'RESET_ONBOARDING';
export const CHANGE_POSITION = 'CHANGE_POSITION';
export const SET_EXIT = 'SET_EXIT';
